<template>
  <div class="privacy container">
    <b-row>
      <b-col md="10" offset-md="1">
        <h2 class="custom-title mt-5">Privacy policy</h2>
        <HideableParagraph
          v-for="(block, idx) in privacyInformation"
          :key="idx"
          :title="block.title"
          :text="block.text"
        >
          <b-table
            v-if="block.title === 'Data we share'"
            class="privacy__table"
            stacked
            outlined
            :items="tableData"
          ></b-table>
        </HideableParagraph>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { privacyInformation, tableData } from './constant';
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'PrivacyPage',

  components: {
    HideableParagraph
  },

  data() {
    return {
      privacyInformation,
      tableData
    };
  },

  head: {
    title: 'Privacy policy | Found',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Information about Found and CCT online privacy policies and practices.'
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
.privacy {
  &__table {
    color: $white-color;
    word-wrap: break-word;
    white-space: pre-line;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
